import {
  Ban,
  CheckCircle2,
  Clock3,
  PackageCheck,
  PackageOpen,
  Timer,
  TimerOff,
  Truck,
  Undo2,
} from 'lucide-react';

import type { OrderStatus } from '../types';

export const orderStatusTone: Record<
  OrderStatus,
  'neutral' | 'success' | 'warning' | 'danger' | 'info'
> = {
  PENDING_PAYMENT: 'neutral',
  PAYMENT_EXPIRED: 'danger',
  CONFIRMED: 'warning',
  PICKING: 'warning',
  PARTIALLY_FULFILLED: 'warning',
  PACKED: 'info',
  DISPATCHED: 'info',
  DELIVERED: 'success',
  CANCELLED: 'neutral',
  RETURNED: 'warning',
};

export const orderStatusIcon = {
  PENDING_PAYMENT: Clock3,
  PAYMENT_EXPIRED: TimerOff,
  CONFIRMED: Clock3,
  PICKING: Timer,
  PARTIALLY_FULFILLED: PackageOpen,
  PACKED: PackageCheck,
  DISPATCHED: Truck,
  DELIVERED: CheckCircle2,
  CANCELLED: Ban,
  RETURNED: Undo2,
} satisfies Record<OrderStatus, typeof Clock3>;

const WIRE_STATUSES = new Set<string>([
  'PENDING_PAYMENT',
  'PAYMENT_EXPIRED',
  'CONFIRMED',
  'PICKING',
  'PARTIALLY_FULFILLED',
  'PACKED',
  'DISPATCHED',
  'DELIVERED',
  'CANCELLED',
  'RETURNED',
]);

export function isKnownOrderStatus(status: string): status is OrderStatus {
  return WIRE_STATUSES.has((status ?? '').trim().toUpperCase());
}

/** Normalize API status to wire enum; map legacy soft labels if needed. */
export function normalizeOrderStatus(status: string): OrderStatus {
  const u = (status ?? '').trim().toUpperCase();
  if (WIRE_STATUSES.has(u)) return u as OrderStatus;

  switch (u) {
    case 'PENDING':
    case 'PENDING_FULFILLMENT':
      return 'CONFIRMED';
    case 'OUT_FOR_DELIVERY':
      return 'DISPATCHED';
    case 'DELAYED':
      return 'DISPATCHED';
    case 'PAYMENT_FAILED':
    case 'EXPIRED':
      return 'PAYMENT_EXPIRED';
    default:
      return 'CONFIRMED';
  }
}
